import { useAppContext } from "@context/app";
import { IFilterAndSortInput, IFilterOutput, IProductList } from "@types";
import { filterApplied_fromEntity } from "@utils/constants";
import { segmentEvent } from "@utils/segment";
import { useRouter } from "next/router";

function useProduct() {
  const { user, country } = useAppContext();
  const { locale } = useRouter();

  const segmentFilterEvent = (
    filter: IFilterOutput[],
    data: IProductList,
    dependencies: {
      filters: IFilterAndSortInput | undefined;
      input: string;
      source: string;
    }
  ) => {
    const { filters, input, source } = dependencies;
    if (!filter.length || !filterApplied_fromEntity.includes(source)) return;
    let filter_gender = "";
    let filter_age = "";
    let filter_price = "";
    let filter_categories = [];
    for (const iterator of filter) {
      for (const _filter of filters?.filters ?? []) {
        if (iterator.key === _filter.key) {
          if (iterator.key === "sku_price") {
            filter_price = _filter.items?.find((x) => x.value === iterator.items?.[0])?.slug ?? "";
          }
          if (iterator.key === "category_id") {
            for (const z of iterator.items ?? []) {
              filter_categories.push(_filter.items?.find((x) => x.value === z)?.slug ?? "");
            }
          }
          if (iterator.key === "attributes_id") {
            if (
              _filter.slug?.includes("age") &&
              _filter.items?.find((x) => x.value === iterator.items?.[0])
            ) {
              filter_age = _filter.items?.find((x) => x.value === iterator.items?.[0])?.slug ?? "";
            }
            if (
              _filter.slug?.includes("gender") &&
              _filter.items?.find((x) => x.value === iterator.items?.[0])
            ) {
              filter_gender =
                _filter.items?.find((x) => x.value === iterator.items?.[0])?.slug ?? "";
            }
          }
        }
      }
    }

    segmentEvent("Filter Applied", {
      user_id: user.data?.id || -1,
      country_id: country?.id,
      country_slug: country?.slug,
      language: locale?.includes("en-") ? "English" : "Arabic",
      filter_gender,
      filter_age,
      filter_price,
      filter_categories,
      from_page: input ? "search_list" : "product_list",
      from_entity: source || "",
      from_entity_slug: data.entity?.slug ?? "",
      from_page_section: "",
      from_page_section_entity: "",
      from_page_section_slug: "",
      filter_page_type: data.entity?.type ?? (input ? "Search" : ""),
      filter_page_id: data.entity?.id ?? -1,
      filter_page_slug: data.entity?.slug ?? "",
    });
  };

  return { segmentFilterEvent };
}

export default useProduct;
